
import React from 'react';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderNewFlowNonScheduledTubesModalStore } from 'application/facility-order-new-flow-order-summary/stores';
import { FacilityOrderNewFlowNonScheduledTubesModalTemplate } from 'themes/application/facility-order-new-flow-order-summary/components';

@setCurrentView((rootStore, componentProps) => new FacilityOrderNewFlowNonScheduledTubesModalStore(rootStore, componentProps), 'facilityOrderNewFlowNonScheduledTubesModalStore')
@observer
class FacilityOrderNewFlowNonScheduledTubesModal extends React.Component {
    render() {
        return <FacilityOrderNewFlowNonScheduledTubesModalTemplate {...this.props} />
    }
}

export default FacilityOrderNewFlowNonScheduledTubesModal;
